import React, { useEffect } from 'react';

declare global {
  interface Window {
    ApexCharts: any;
  }
}

const Chart = () => {
  useEffect(() => {
    const options = {
      colors: ['#1A56DB', '#FDBA8D', '#31C48D'],
      series: [
        {
          name: 'Horizontal 120 (Heating Oil)',
          data: [50, 70, 60, 120, 110, 90]
        },
        {
          name: 'Horizontal 500 (Propane)',
          data: [250, 450, 400, 500, 480, 450] 
        },
        {
          name: 'Horizontal 2000 (Diesel)',
          data: [1000, 1500, 1400, 1900, 1800, 1600] 
        }
      ],
      chart: {
        type: 'line',
        height: 500,
        fontFamily: 'Inter, sans-serif'
      },
      markers: {
        size: 5
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      tooltip: {
        shared: true,
        intersect: false
      },
      xaxis: {
        categories: [
          'Oct 2023',
          'Nov 2023',
          'Dec 2023',
          'Jan 2024',
          'Feb 2024',
          'Mar 2024'
        ],
        title: {
          text: 'Month'
        }
      },
      yaxis: {
        title: {
          text: 'Gallons'
        },
        min: 0,
        max: 2000,
        tickAmount: 10
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        itemMargin: {
          horizontal: 5,
          vertical: 0
        },
        onItemClick: {
          toggleDataSeries: true
        },
        onItemHover: {
          highlightDataSeries: true
        }
      }
    };

    if (typeof window !== 'undefined' && window.ApexCharts) {
      const chart = new window.ApexCharts(
        document.querySelector('#main-chart'),
        options
      );
      chart.render();
    }
  }, []);

  return (
    <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2">
      {/* <div className="flex items-center justify-between mb-4">
        <div className="flex-shrink-0">
          <span className="text-xl font-bold leading-none text-gray-900">
            $45,385
          </span>
          <h3 className="text-base font-light text-gray-500">
            Sales this week
          </h3>
        </div>
        <div className="flex items-center justify-end flex-1 text-base font-medium text-green-500">
          12.5%
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z"></path>
          </svg>
        </div>
      </div> */}
      <div id="main-chart" style={{ height: '320px', width: '100%' }}></div>
      {/* <div className="flex items-center justify-between pt-3 mt-4 border-t border-gray-200">
        <div>
          <button className="inline-flex items-center p-2 text-sm font-medium text-gray-500 rounded-lg hover:text-gray-900">
            Last 7 days
            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
        </div>
        <div className="flex-shrink-0">
          <a href="#" className="inline-flex items-center p-2 text-xs font-medium uppercase rounded-lg text-blue-600 hover:bg-gray-100">
            Sales Report
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default Chart;
